import api from '@/api.js'

const state = {
    users: [],
    smsapies: [],
    companies: []
}

const getters = {
    users: state => {
        return state.users;
    },
    isUsers: state => {
        return state.users.length;
    },
    companies: state => {
        return state.companies;
    },
    company: state => {
        return (id) => {
            const o = state.companies.find(e => { return e.idx == id });
            return o ? o : {};
        }
    },
    smsapi: state => {
        return (id) => {
            const o = state.smsapies.find(e => { return e.idx == id; });
            return o ? o : {};
        }
    },
    isCompanies: state => {
        return state.companies.length;
    },
    smsapies: state => {
        return state.smsapies;
    },
    isSmsapies: state => {
        return state.smsapies.length;
    }
}
const actions = {
    //SMSAPIES
    LOAD_SMSAPIES: function (context) {
        api.getSmsapies().then(response => {
            context.commit("setSmsapies", response);
        });
    },
    INSERT_SMSAPI: function (context, payload) {
        api.insertSmsapi(payload).then(response => {
            if (response) context.commit("insertSmsapi", { ...payload, idx: response })
        })
    },
    UPDATE_SMSAPI: function (context, payload) {
        api.updateSmsapi(payload.item).then(response => {
            if (response) context.commit("updateSmsapi", payload)
        })
    },
    DELETE_SMSAPI: function (context, payload) {
        api.deleteSmsapi(payload.idx).then(response => {
            if (response) context.commit("deleteSmsapi", payload)
        })
    },
    // COMPANIES    
    LOAD_COMPANIES: function (context) {
        api.getCompanies().then(response => {
            context.commit("setCompanies", response);
        });
    },
    INSERT_COMPANY: function (context, payload) {
        api.insertCompany(payload).then(response => {
            if (response) context.commit("insertCompany", { ...payload, idx: response })
        })
    },
    UPDATE_COMPANY: function (context, payload) {
        api.updateCompany(payload.item).then(response => {
            if (response) context.commit("updateCompany", payload)
        })
    },
    ADD_TO_COMPANY: async function (context, payload) {
        await api.add2companyDebit(payload.idx, payload.data).then((response) => {
            context.commit("updateCompanyDebit", {idx:payload.editIndex,debit:response})
        });
    },
    DELETE_COMPANY: function (context, payload) {
        api.deleteCompany(payload.idx).then(response => {
            if (response) context.commit("deleteCompany", payload)
        })
    },
    // USERS    
    LOAD_USERS: function (context) {
        api.getUsers().then(response => {
            context.commit("setUsers", response);
        });
    },
    UPDATE_USER: function (context, payload) {
        api.updateUser(payload.item).then(response => {
            if (response) context.commit("updateUser", payload);
        });
    },
    INSERT_USER: function (context, payload) {
        api.insertUser(payload).then(response => {
            if (response) context.commit("insertUser", { ...payload, idx: response });
        });
    },
    DELETE_USER: function (context, payload) {
        api.deleteUser(payload.idx).then(response => {
            if (response) context.commit("deleteUser", payload);
        });
    },
}
const mutations = {
    //SMSAPIES
    setSmsapies: (state, payload) => {
        state.smsapies = payload;
    },
    insertSmsapi: (state, payload) => {
        state.smsapies.push({ ...payload });
    },
    updateSmsapi: (state, payload) => {
        Object.assign(state.smsapies[payload.index], payload.item);
    },
    deleteSmsapi: (state, payload) => {
        const index = state.smsapies.indexOf(payload);
        state.smsapies.splice(index, 1)
    },
    //COMPANIES 
    updateCompanyDebit:(state, payload) => {
        state.companies[payload.idx].debit = payload.debit;
    },
    setCompanies: (state, payload) => {
        state.companies = payload;
    },
    insertCompany: (state, payload) => {
        state.companies.push({ ...payload });
    },
    updateCompany: (state, payload) => {
        Object.assign(state.companies[payload.index], payload.item);
    },
    deleteCompany: (state, payload) => {
        const index = state.companies.indexOf(payload);
        state.companies.splice(index, 1)
    },
    // USERS
    setUsers: (state, payload) => {
        state.users = payload;
    },
    updateUser: (state, payload) => {
        Object.assign(state.users[payload.index], payload.item);
    },
    insertUser: (state, payload) => {
        state.users.push({ ...payload });
    },
    deleteUser: (state, payload) => {
        const index = state.users.indexOf(payload);
        state.users.splice(index, 1)
    },
}

const Data = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}

export default Data;